import React, { useState } from "react";
import { Button, Card, CardHeader, CheckCircle } from "@opendate-app/setlist";
import { formatDateTime } from "../../ClassesShared/classLabels";
import { useRegistrationPageContext } from "./RegistrationPageContext";
import "../registrationPage.css";
import "../../ClassesShared/classesShared.css";

export default function CommunicationsCard() {
  const { registration, canResend, resendConfirmation } = useRegistrationPageContext();
  const [sending, setSending] = useState(false);
  const { communications, time_zone: timeZone } = registration.dashboard;

  const resend = async () => {
    if (sending) return;
    setSending(true);
    await resendConfirmation();
    setSending(false);
  };

  const resendAction = canResend && registration.confirmation_resendable ? (
    <Button variant="secondary" size="sm" onClick={resend} aria-disabled={sending} aria-busy={sending} data-testid="resend-confirmation">
      {sending ? "Sending…" : "Resend"}
    </Button>
  ) : null;

  return (
    <Card header={<CardHeader title="Communications" actions={resendAction} />}>
      {communications.length === 0 && <div className="classes-text-secondary">No emails sent to this attendee yet.</div>}
      <div className="d-flex flex-column classes-gap-16">
        {communications.map((message) => (
          <div key={message.id} className="d-flex align-items-start classes-gap-12" data-testid="registration-communication">
            <span className="registration-communication__icon" aria-hidden="true"><CheckCircle width={16} height={16} /></span>
            <div className="flex-grow-1">
              <div className="font-weight-bold small">{message.subject}</div>
              <div className="small classes-text-secondary">
                {`${formatDateTime(message.sent_at, timeZone)}${message.opened_at ? " · Opened" : ""}`}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
